module.exports = __webpack_public_path__ + "img/logo.163413b3.png";